<template>
  <div class="mb-3">
    <!-- Label -->
    <label v-if="label" class="form-label"> <b>{{ label }} </b></label>
     <!-- Month Picker -->
    <VueDatePicker v-model="internalValue" :disabled="disabled" :readonly="readonly" type="month" locale="fr"
      :cancelText="i18n.t('button.cancel')" :selectText="i18n.t('button.select')" :enable-time-picker="false"
       month-picker />

    <!-- Validation errors -->
    <span v-if="v">
      <span class="text-danger" v-for="error in v?.$errors" :key="error.$uid">
        - {{ error.$message }} <br>
      </span>
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch, defineProps, defineEmits, PropType } from 'vue';
import i18n from "@/i18n/index";

const props = defineProps({
  modelValue: {
    type: Object,
    default: null,
  },
  readonly: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  label: { type: String },
  v: { type: Object }, // validation object
  
});

const emits = defineEmits(['update:modelValue']);

// Internal value to bind to VueDatePicker
const internalValue = ref<Object | null>(props.modelValue);

 

// Watch internal value and emit YYYY-MM string
watch(internalValue, (newValue) => {
  emits('update:modelValue', newValue); // string or null
});

// Watch prop updates
watch(() => props.modelValue, (newValue) => {
  internalValue.value = newValue;
});
</script>

<style scoped>
/* Optional: style disabled input if needed */
input[disabled] {
  opacity: 0.6;
}
</style>
